var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.72 7.456H16.36l-4.692-4.488a.326.326 0 0 0-.22-.088H1.28C.572 2.88 0 3.452 0 4.16v23.68c0 .708.572 1.28 1.28 1.28h29.44c.708 0 1.28-.572 1.28-1.28V8.736c0-.708-.572-1.28-1.28-1.28zm-1.6 18.784H2.88V5.76h7.54l4.784 4.576H29.12V26.24z",
    fill: "#1B1C1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.83febf5c7dfe35ce7ca45b128ee22609.svg";
export { ForwardRef as ReactComponent };